import axios from ".";
import apiClient from "./apiClient";
import { globalLoaderDecrement, globalLoaderIncrement } from "../redux/actions/GlobalLoaderActions";

let initialized = false;

function attach(instance, dispatch) {
  instance.interceptors.request.use(
    (config) => {
      const skip = config?.headers?.["x-skip-global-loader"] === true;
      if (!skip) {
        config.__globalLoaderTracked = true;
        dispatch(globalLoaderIncrement());
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => {
      if (response?.config?.__globalLoaderTracked) dispatch(globalLoaderDecrement());
      return response;
    },
    (error) => {
      if (error?.config?.__globalLoaderTracked) dispatch(globalLoaderDecrement());
      return Promise.reject(error);
    }
  );
}

export function setupGlobalLoaderInterceptors(store) {
  if (initialized) return;
  initialized = true;

  const dispatch = store.dispatch;
  attach(axios, dispatch);
  attach(apiClient, dispatch);
}

